import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { dopContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const AllowanceDop = () => {
  // const [balance, setBalance] = useState(null)
  const { account, chainId } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress = Environment.presaleContract;
  const tokenAddress1 = Environment.dop;
  const contract = dopContract(tokenAddress1, web3);

  const allowanceDop = useCallback(async () => {
    // console.log(tokenAddress,account,'noor');
    console.log(chainId, "Chain Id");
    try {
      const buy = await contract.methods
        .allowance(account, tokenAddress)
        .call();
      return buy / 10 ** 18;
    } catch (error) {
      throw error;
    }
  }, [contract, account, web3]);
  return { allowanceDop: allowanceDop };
};
export default AllowanceDop;
